<template>
  <div>
    <div v-if="this.$store.state.device.isMobile">
      <navbarTop></navbarTop>
      <navbarBottom></navbarBottom>
      <div style="position: relative;">
        <b-form class="form">
          <b-row class="progress_row">
            <b-col class="progress_col" cols="2"><span class="dot_active" :style="{'border': '3px solid'+this.$store.state.device.color, 'background-color':this.$store.state.device.color }"><span class="number_progression_active"><b>1</b></span></span></b-col>
            <b-col class="progress_col" cols="3"><hr class="hr" :style="{'background-color': this.$store.state.device.color}"></b-col>
            <b-col class="progress_col" cols="2"><span class="dot_not_active" :style="{'border': '3px solid'+this.$store.state.device.color}"><span class="number_progression_not_active">2</span></span></b-col>
            <b-col class="progress_col" cols="3"><hr class="hr" :style="{'background-color': this.$store.state.device.color}"></b-col>
            <b-col class="progress_col" cols="2"><span class="dot_not_active" :style="{'border': '3px solid'+this.$store.state.device.color}"><span class="number_progression_not_active">3</span></span></b-col>
          </b-row>
          <div style="width: 80%;margin: 10% auto 20%;">
            <div style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.PersonalData') }}</b></label></div>
            <br>
            <br>
            <b-form-group v-if="invalidName">
              <legend><span style="color: red;">*</span>{{ $t('pages.Registration.Name') }}</legend>
              <b-form-input
                      style="border: 2px solid red;"
                      v-model="form.name"
              ></b-form-input>
            </b-form-group>
            <b-form-group v-if="!invalidName">
              <legend>{{ $t('pages.Registration.Name') }}</legend>
              <b-form-input
                      v-model="form.name"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <legend>{{ $t('pages.Registration.Email') }}</legend>
              <b-form-input
                      v-model="form.email"
                      placeholder="example@example.pt"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <legend>{{ $t('pages.Registration.BirthdayDate') }}</legend>
              <b-form-input
                      type="date"
                      v-model="form.birthday_date"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <legend>{{ $t('pages.Registration.Phone') }}</legend>
              <VuePhoneNumberInput :color="this.$store.state.device.color" default-country-code="PT" v-model="form.phone_number" />
            </b-form-group>

            <b-form-group>
              <legend>{{ $t('pages.Registration.Location') }}</legend>
              <gmap-autocomplete
                      :options="autocompleteOptions"
                      @place_changed="setPlace"
                      class="form-control input"
                      style="width: 100%">
              </gmap-autocomplete>
            </b-form-group>

            <div class="repor">
              <a v-on:click="repor" style="">{{$t('standard.reset')}}</a>
            </div>

            <b-button id="btnNext" v-on:click="verifyData">
                {{$t('standard.next')}}
                <i style="padding-left: 10px;" class="fas fa-arrow-circle-right"></i>
            </b-button>

          </div>
        </b-form>
      </div>
      </div>
    <div v-if="this.$store.state.device.isDesktop">
      <navbarTop></navbarTop>
      <sideBar></sideBar>
      <div class="desktop_container">
        <div style="padding: 16px;" v-if="width>1200">
            <h5 style="text-align: left"><b>{{ $t('pages.Menu.Registration') }}</b></h5>
            <hr style="background-color: #8D99AE; border: 1px solid #8D99AE">

            <div style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.PersonalData') }}</b></label></div>
            <br>
            <br>
            <b-row>
              <b-col cols="4" v-if="invalidName">
                <b-form-group>
                  <legend><span style="color: red;">*</span>{{ $t('pages.Registration.Name') }}</legend>
                  <b-form-input
                          style="border: 2px solid red;"
                          v-model="form.name"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="4" v-if="!invalidName">
                <b-form-group>
                  <legend>{{ $t('pages.Registration.Name') }}</legend>
                  <b-form-input
                          v-model="form.name"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group>
                  <legend>{{ $t('pages.Registration.Email') }}</legend>
                  <b-form-input
                          v-model="form.email"
                          placeholder="example@example.pt"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group>
                  <legend>{{ $t('pages.Registration.BirthdayDate') }}</legend>
                  <b-form-input
                          type="date"
                          v-model="form.birthday_date"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <b-form-group>
                  <legend>{{ $t('pages.Registration.Phone') }}</legend>
                  <VuePhoneNumberInput :color="this.$store.state.device.color" default-country-code="PT" v-model="form.phone_number" />
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group>
                  <legend>{{ $t('pages.Registration.Location') }}</legend>
                  <gmap-autocomplete
                          :options="autocompleteOptions"
                          @place_changed="setPlace"
                          class="form-control input"
                          style="width: 100%">
                  </gmap-autocomplete>
                </b-form-group>
              </b-col>
              <b-col cols="4"></b-col>
            </b-row>
            <br>
            <div style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.PaymentTitle') }}</b></label></div>
            <br>
            <br>
            <b-row>
              <b-col cols="4">
                <b-form-group>
                  <legend>{{ $t('pages.Registration.MemberType') }}</legend>
                  <b-form-group style="margin-top: 5%;">
                    <b-form-select style="width: 100%; border-radius: 32px;" v-model="type" :options="options_type"></b-form-select>
                  </b-form-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group>
                  <legend>{{ $t('pages.Registration.PaymentLabel') }}</legend>
                  <b-form-group style="margin-top: 5%;">
                    <b-form-select style="width: 100%; border-radius: 32px;" v-model="selected" :options="options"></b-form-select>
                  </b-form-group>
                </b-form-group>
              </b-col>
              <b-col cols="4"></b-col>
            </b-row>
        </div>

        <div style="padding: 16px;" v-else>
          <h5 style="text-align: left"><b>{{ $t('pages.Menu.Registration') }}</b></h5>
          <hr style="background-color: #8D99AE; border: 1px solid #8D99AE">

          <div style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.PersonalData') }}</b></label></div>
          <br>
          <br>
          <b-row>
            <b-col cols="6" v-if="invalidName">
              <b-form-group>
                <legend><span style="color: red;">*</span>{{ $t('pages.Registration.Name') }}</legend>
                <b-form-input
                        style="border: 2px solid red;"
                        v-model="form.name"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6" v-if="!invalidName">
              <b-form-group>
                <legend>{{ $t('pages.Registration.Name') }}</legend>
                <b-form-input
                        v-model="form.name"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <legend>{{ $t('pages.Registration.Email') }}</legend>
                <b-form-input
                        v-model="form.email"
                        placeholder="example@example.pt"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group>
                <legend>{{ $t('pages.Registration.BirthdayDate') }}</legend>
                <b-form-input
                        type="date"
                        v-model="form.birthday_date"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <legend>{{ $t('pages.Registration.Phone') }}</legend>
                <VuePhoneNumberInput :color="this.$store.state.device.color" default-country-code="PT" v-model="form.phone_number" />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group>
                <legend>{{ $t('pages.Registration.Location') }}</legend>
                <gmap-autocomplete
                        :options="autocompleteOptions"
                        @place_changed="setPlace"
                        class="form-control input"
                        style="width: 100%">
                </gmap-autocomplete>
              </b-form-group>
            </b-col>
            <b-col cols="6"></b-col>
          </b-row>
          <br>
          <div style="left: 0;"><label style="float: left;"><b>{{ $t('pages.Registration.PaymentTitle') }}</b></label></div>
          <br>
          <br>
          <b-row>
            <b-col cols="4">
              <b-form-group>
                <legend>{{ $t('pages.Registration.MemberType') }}</legend>
                <b-form-group style="margin-top: 5%;">
                  <b-form-select style="width: 100%; border-radius: 32px;" v-model="type" :options="options_type"></b-form-select>
                </b-form-group>
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <b-form-group>
                <legend>{{ $t('pages.Registration.PaymentLabel') }}</legend>
                <b-form-group>
                  <b-form-select style="width: 100%; border-radius: 32px;" v-model="selected" :options="options"></b-form-select>
                </b-form-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <div class="footer_desktop">
          <hr class="bottom_line">
          <div class="footer_content_right">
            <a v-on:click="repor" style="text-decoration: underline;">{{$t('standard.reset')}}</a>
            <b-button id="nextDesktop" v-on:click="verifyDataDesktop">{{ $t('standard.next') }}</b-button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import NavbarTop from "../components/navbarTop";
  import navbarBottom from "../components/navbarBottom";
  import VuePhoneNumberInput from "vue-phone-number-input";
  import {mutations} from "../store/modules/createSocio";
  import sideBar from "../components/sideBar"
  const pt = require('../translations/pt-PT/pt-PT');
  const en = require('../translations/en-GB/en-GB');
  export default {
    name: "Registar",
    data() {
      return {
        width: null,
        invalidName: true,
        form: {
          name: "",
          birthday_date: null,
          phone_number: "",
          address: "",
          email: ""
        },
        autocompleteOptions: {
          componentRestrictions: {
            country: [
              'pt',
            ],
          },
        },
        selected: 0,
        options: [],
        options_type: [],
        type: 1
      };
    },
    components: { NavbarTop, navbarBottom, sideBar, VuePhoneNumberInput},
    methods: {
      verifyData() {
        if(this.form.name==""){
          if(this.$i18n.locale()=='pt') this.$toast.open({message: pt.pages.Registration.InvalidName, type: 'is-danger'});
          if(this.$i18n.locale()=='en') this.$toast.open({message: en.pages.Registration.InvalidName, type: 'is-danger'});
          this.invalidName=true;
        }else{this.next()}
      },
      next() {
        this.invalidName=true;
        mutations.changeEmail(this.form.email);
        mutations.changeName(this.form.name);
        mutations.changeBirthdayDate(this.form.birthday_date);
        mutations.changePhoneNumber(this.form.phone_number);
        mutations.changeAddress(this.form.address);
        mutations.changeNumberOfPayments(this.selected);
        mutations.changeType(this.type);
        this.$router.push('/createSocio2');
      },
      verifyDataDesktop() {
        if(this.form.name==""){
            if(this.$i18n.locale()=='pt') this.$toast.open({message: pt.pages.Registration.InvalidName, type: 'is-danger'});
            if(this.$i18n.locale()=='en') this.$toast.open({message: en.pages.Registration.InvalidName, type: 'is-danger'});
            this.invalidName=true;
        }else{this.nextDesktop()}
      },
      nextDesktop() {
        this.invalidName=true;
        mutations.changeEmail(this.form.email);
        mutations.changeName(this.form.name);
        mutations.changeBirthdayDate(this.form.birthday_date);
        mutations.changePhoneNumber(this.form.phone_number);
        mutations.changeAddress(this.form.address);
        mutations.changeNumberOfPayments(this.selected);
        mutations.changeType(this.type);
        this.$router.push('/createSocio3');
      },
      setPlace(place) {
        this.form.address = place.name;
      },
      repor() {
        this.form.name = "";
        this.form.birthday_date = null;
        this.form.phone_number = "";
        this.form.address = "";
        this.form.email = "";
        this.selected = 0;
        this.type = 1;
        mutations.changeName(this.form.name);
        mutations.changeEmail(this.form.email);
        mutations.changeBirthdayDate(this.form.birthday_date);
        mutations.changePhoneNumber(this.form.phone_number);
        mutations.changeAddress(this.form.address);
        mutations.changeNumberOfPayments(this.selected);
        mutations.changeType(this.type);
      }
    },
    mounted() {
      this.width = Math.max(self.innerWidth || 0, document.documentElement.clientWidth || 0, document.body.clientWidth || 0);
      this.form.name = this.$store.state.createSocio.name;
      this.form.birthday_date = this.$store.state.createSocio.birthday_date;
      this.form.phone_number = this.$store.state.createSocio.phone_number;
      this.form.address = this.$store.state.createSocio.address;
      this.form.email = this.$store.state.createSocio.email;
      this.selected = this.$store.state.createSocio.number_of_payments_year;
      this.type = this.$store.state.createSocio.type;
      if(this.$i18n.locale()=='pt') {
        this.options_type = [{ value: 1, text: pt.pages.Registration.TypeNormal },
          { value: 2, text: pt.pages.Registration.TypeElderly },
          { value: 3, text: pt.pages.Registration.TypeChild },
          { value: 4, text: pt.pages.Registration.TypeAthlete },
          { value: 5, text: pt.pages.Registration.TypeWoman }]
      }
      if(this.$i18n.locale()=='en') {
        this.options_type = [{ value: 1, text: pt.pages.Registration.TypeNormal },
          { value: 2, text: en.pages.Registration.TypeElderly },
          { value: 3, text: en.pages.Registration.TypeChild },
          { value: 4, text: en.pages.Registration.TypeAthlete },
          { value: 5, text: en.pages.Registration.TypeWoman }]
      }
      if(this.$i18n.locale()=='pt') {
        this.options = [{ value: 0, text: pt.pages.Registration.PaymentDropNoPayment },
          { value: 1, text: pt.pages.Registration.PaymentDropMonth },
          { value: 3, text: pt.pages.Registration.PaymentDropTrimester },
          { value: 6, text: pt.pages.Registration.PaymentDropSemester },
          { value: 12, text: pt.pages.Registration.PaymentDropYear }]
      }
      if(this.$i18n.locale()=='en') {
        this.options = [{ value: 0, text: en.pages.Registration.PaymentDropNoPayment },
          { value: 1, text: en.pages.Registration.PaymentDropMonth },
          { value: 3, text: en.pages.Registration.PaymentDropTrimester },
          { value: 6, text: en.pages.Registration.PaymentDropSemester },
          { value: 12, text: en.pages.Registration.PaymentDropYear }]
      }
    }
  };
</script>

<style scoped>
  .form {
    padding-top: 80px;
    padding-bottom: 40px;
  }
  .progress_row {
    width: 80%;
    margin: auto;
  }
  .progress_col {
    padding: 0;
  }
  #btnNext {
    width: 40%;
    background: #2B2D42 0% 0% no-repeat padding-box;
    border-radius: 32px;
    color: white;
    border: none;
    letter-spacing: 0.85px;
    text-align: center;
    position: fixed;
    bottom: 68px;
    right: 10px;
  }
  @media (max-width: 330px) {
    .hr {
      border: none;
      height: 3px;
      position: relative;
      margin: 30% auto auto;
    }
  }
  @media (min-width: 330px) {
    .hr {
      border: none;
      height: 3px;
      position: relative;
      margin: 25% auto auto;
    }
  }
  input {
    background: white;
    border-radius: 32px;
    height: 47px;
    border-color: #2B2D42;
  }

  legend {
    color: #2B2D42;
    text-align: left;
    font-size: 16px;
    letter-spacing: 0.8px;
    margin-bottom: 2%;
  }

  .hr {
    border: none;
    height: 3px;
    position: relative;
    margin: 25% auto auto;
  }

  .dot_not_active {
    height: 100%;
    width: 100%;
    background-color: white;
    border-radius: 50%;
    display: flex;
  }

  .dot_active {
      height: 100%;
      width: 100%;
      border-radius: 50%;
      display: flex;
  }

  .number_progression_not_active {
      color: #2B2D42 ;
      margin: auto;
      font-size: 20px;
  }

  .number_progression_active {
      color: white;
      margin: 10%;
      font-size: 20px;
      padding-left: 25%;
  }
  .repor {
    text-align: center;
    margin-top: 5%;
    text-decoration: underline;
  }
  #nextDesktop {
    background: #2B2D42 0% 0% no-repeat padding-box;
    border-radius: 28pt;
    color: white;
    border: none;
    letter-spacing: 0.85px;
    margin-left: 20px;
  }
  .btnSend {
    height: 7vh;
    width: 10vw;
    background: #2B2D42 0% 0% no-repeat padding-box;
    border-radius: 32px;
    color: white;
    border: none;
    letter-spacing: 0.85px;
    text-align: center;
    position: fixed;
    bottom: 5vh;
    right: 3%;
    font-size: 125%;
  }
</style>
